<div class="card"> 
    <div class="card-container">
        <div class="flex-2 p-4 grid">
            <div class="col-6">
                <label for="barcode">Check Plate Barcode:</label><br>
                <input [(ngModel)]="barcode" id="barcode" type="text" pInputText ><br><br>
                <p-button (click)="getTrackerInfo()">Check</p-button><br><br>
                
                <p-checkbox [binary]="true" value="showMachines" label="Show Machine Names" [(ngModel)]="showMachines"></p-checkbox><br><br>
                <p-checkbox [binary]="true" value="showAdditionalInfo" label="Show Additional Information" [(ngModel)]="showAdditionalInfo"></p-checkbox><br><br>
                <p-checkbox [binary]="true" value="showPred" label="Show Predictions" [(ngModel)]="showPred"></p-checkbox>
            </div>
            <div class="col-6">
                <h4>Similarity Check</h4>
                <p-checkbox [binary]="true" value="useRetests" label="Use Retests" [(ngModel)]="useRetests"></p-checkbox><br><br>
                <p-button (click)="calculateSimilarity()">Calculate In App</p-button>&nbsp;
                <p-button (click)="exportToExcel()">Export Raw Data</p-button><br><br>
                <div *ngFor="let status of machinePercentages">
                    <div *ngIf="status.machines.length > 0">
                        <h5>{{status.name}}</h5>
                        <div *ngFor="let machine of status.machines">
                            {{machine.name}} - {{machine.percent}}<br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="loading && searched" class="flex-1 p-4">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <div *ngFor="let timelines of listOfTimelines">
            <br>
            <hr>
            <br>
            <div class="p-4" style="display:inline-flex;">
                <div *ngFor="let timeline of timelines">
                    <div *ngIf="showAdditionalInfo" class="row text-center">
                        <label>Number of Samples: {{timeline.detail.numSamples}}</label><br>
                        <label>Worklist: {{timeline.detail.worklistName}}</label><br>
                        <label>Strains: {{timeline.detail.strainName}}</label><br>
                        <label>User: {{timeline.detail.fullName}}</label><br>
                        <label>Organization: {{timeline.detail.organization}}</label><br>
                        <label>Source Plate: {{timeline.detail.sPlate}}</label><br>
                        <label>Dest Plate: {{timeline.detail.dPlate}}</label><br>
                        <label>A Plate: {{timeline.detail.aPlate}}</label><br>
                        <label>MM Plate: {{timeline.detail.mmPlate}}</label><br>
                        <label>PLV Plate: {{timeline.detail.plvPlate}}</label><br>
                        <label>Retest: {{timeline.detail.retestType}}</label><br><br>
                    </div>
                    <div class="row" style="display:block;width:500px;">
                        <p-timeline *ngIf="!loading" [value]="timeline.events" class="w-full">
                            <ng-template pTemplate="marker" let-event>
                                <span class="custom-marker shadow-2" [style.backgroundColor]="event.color">
                                    <i [ngClass]="event.icon"></i>
                                </span>
                            </ng-template>
                            <ng-template pTemplate="content" let-event>
                                <small *ngIf="showPred" class="p-text-secondary">Predicted - {{event.predictedDate | date:'short'}}</small><br>
                                <small *ngIf="showPred"  class="p-text-secondary">Actual - {{event.actualDate | date:'short'}}</small>
                            </ng-template>
                            <ng-template pTemplate="opposite" let-event>
                                {{event.status}}<br>
                                <small *ngIf="showMachines" class="p-text-secondary">{{event.machineName}}</small>
                            </ng-template>
                        </p-timeline>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>